import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FileResponse, MojaFirmaClient } from '@kodit/core/data-api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertService } from '@kodit/core/services';

@Component({
  selector: 'kodit-logo-upload',
  templateUrl: './logo-upload.component.html',
  styleUrls: ['./logo-upload.component.scss'],
})
export class LogoUploadComponent implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();
  /** Props */
  @ViewChild('editLogoRef') editLogoRef: FileUpload;
  uploadCompleted: boolean;
  logoImage: any;

  constructor(
    private _alertService: AlertService,
    private _client: MojaFirmaClient,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this._getLogo();
  }

  onEditLogo(event: any) {
    if (event.files[0]) {
      this.onUpload(event.files[0]);
      this.editLogoRef.clear();
    }
  }

  onUpload(file: File) {
    this.uploadCompleted = false;
    this._subs.add(
      this._client
        .uploadLogo({ data: file, fileName: file.name })
        .subscribe((res) => {
          this.uploadCompleted = true;
          this._alertService.addSuccessMsg(res.messages[0]);
          this._getLogo();
        })
    );
  }

  private _getLogo() {
    this._subs.add(
      this._client.getLogo().subscribe((res: FileResponse) => {
       // this.logoImage = res.data;

        const objectURL = URL.createObjectURL(res.data);
        this.logoImage = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
